<template>
    <div class="mt-6 mb-1" style="max-width: 320px;">
        <v-flex v-if="text" xs12 mb-4>
            <p v-html="text"/>
        </v-flex>
        <v-flex xs12 v-show="showBasicLogin && !identityProvider || identityProvider==='basic'">
            <v-expansion-panels class="elevation-0">
                <v-expansion-panel class="mb-1 elevation-0">
                    <v-expansion-panel-header class='loginExpensionHeader'>{{$t("LOGIN_BASIC_LOGIN")}}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <basic-auth @confirm="confirm" class="pa-3"/>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-flex>
        <v-flex xs12 mb-4 v-show="providers.includes('google') && googleLoginEnabled && (!identityProvider || identityProvider==='google')">
            <google-sign-in-button @confirm="confirm" :scopes='["profile", "email", "openid"]' />
        </v-flex>
        <v-flex xs12 mb-4 v-show="providers.includes('azure') && azureAdLoginEnabled && (!identityProvider || identityProvider==='azuread')">
            <msal-login-button @confirm="confirm" />
        </v-flex>
        <v-flex xs12 mb-4 v-show="identityProvider">
            <v-btn block class="elevation-0" style="background-color: white" @click="showAllLoginOptions">Other Login Options</v-btn>
        </v-flex>
        <v-flex xs12 mb-4 style="max-width: 320px;" v-show="providers.includes('credential_user') && (credentialUserLoginEnabled && (!identityProvider || identityProvider==='credential_user'))">
            <credential-user-login-button @confirm="confirm" :credential-code="credentialCode" :mode="mode" :competitionId="competitionId"/>
        </v-flex>
        <v-flex xs12 mb-4 style="max-width: 320px;" v-show="providers.includes('credential_anonymous') && featureSignInAsAnonymousUserEnabled && (!identityProvider || identityProvider==='credential_anonymous')">
            <credential-anonymous-login-button @confirm="confirm" :credential-code="credentialCode" :mode="mode" :competitionId="competitionId"/>
        </v-flex>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import BasicAuth from "./providers/BasicAuth.vue";
import GoogleSignInButton from "./providers/GoogleSignInButton.vue";
import MsalLoginButton from "./providers/MsalLoginButton.vue";
import CredentialUserLoginButton from "./providers/CredentialUserLoginButton.vue";
import CredentialAnonymousLoginButton from "./providers/CredentialAnonymousLoginButton.vue";
import Config from "@/config";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { resolve } from 'url';
import { useApiClientStore } from "@/stores/apiClientStore";
import { useAuthenticationStore } from "@/stores/authenticationStore";
import { useFeatureStore } from "@/stores/featureStore";

@Component({
    components: { BasicAuth, GoogleSignInButton, MsalLoginButton, CredentialUserLoginButton, CredentialAnonymousLoginButton }
})
export default class LoginButtons extends Vue {
    @Prop() text:string;
    @Prop() mode: string;
    @Prop() competitionId: string;
    @Prop() credentialCode;
    @Prop() providers: string[];
    get loading() { return useApiClientStore().isLoading; }
    get identityProvider() { return useAuthenticationStore().identityProvider; }
    get googleLoginEnabled() { return useFeatureStore().googleLoginEnabled; }
    get azureAdLoginEnabled() { return useFeatureStore().azureAdLoginEnabled; }
    resetIdentityProvider = () => useAuthenticationStore().resetIdentityProvider('');

    get newAccountLink() {
        return Config.BASE_DOMAIN === 'VACR' ? resolve(Config.CYBER_RANGE_UI_BASE_URL, '/signup?code=vacr') : resolve(Config.HOMEPAGE_UI_BASE_URL, '/contact-us');
    }
    
    get showBasicLogin() {
        return Config.BASIC_LOGIN_ENABLED;
    }

    get featureSignInAsAnonymousUserEnabled():boolean
    {
        return !!Config.FEATURE_SIGN_IN_AS_ASNONYMOUS_USER_ENABLED;
    }

    get credentialUserLoginEnabled(): boolean {
        return Config.CREDENTIAL_USER_LOGIN_ENABLED;
    }

    confirm() {
        this.$emit("confirm");
    }
    showAllLoginOptions() {
        this.resetIdentityProvider();
    }
}
</script>

<style scoped>
.loginExpensionHeader
{
    font-size: 0.875rem;
    font-weight: 500;
    letter-spacing: 0.08928571em;
    padding-left: 36px !important;
}
</style>